import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import FeedingBargesForm from '../Forms/FeedingBargesForm';

const AddEditFeedingBargesModal = ({
	dataFeedingBarges,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Artefacto Naval
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem><NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>Información General</NavLink></NavItem>
					{isEdit &&
						<React.Fragment>
							<NavItem><NavLink href='#' className={classnames({ active: activeTab === '2' })} onClick={() => { toggleTab('2'); }}>Silos de Alimento</NavLink></NavItem>
							<NavItem><NavLink href='#' className={classnames({ active: activeTab === '3' })} onClick={() => { toggleTab('3'); }}>Estanque de Combustible</NavLink></NavItem>
							<NavItem><NavLink href='#' className={classnames({ active: activeTab === '4' })} onClick={() => { toggleTab('4'); }}>Fuente de Energía</NavLink></NavItem>
						</React.Fragment>
					}
				</Nav>
			</div>

			<FeedingBargesForm
				dataFeedingBarges={dataFeedingBarges}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditFeedingBargesModal;
